// 应用配置
export const APP_CONFIG = {
  // 后端API地址 - 使用相对路径，通过Vue代理解决CORS问题
  BASE_API: 'https://datas.8090pay.com', // 开发环境使用相对路径 https://datas.8090pay.com
  
  // 应用信息
  APP_ID: 15, // 企业服务平台的ID - 修改为1匹配数据库中的现有应用
  APP_KEY: '0C0qiICSs2exkkrjwxjlEQ==',  // 从service_platform_backend获取的应用密钥 - 修改为默认密钥
  
  // 支付配置
  DEFAULT_PAYMENT_METHOD: 'epay_alipay', // 默认支付方式
  
  // 其他配置
  TIMEOUT: 15000, // 请求超时时间
  
  // 业务类型配置
  // 可选值: 'electronics'(电子产品), 'internet'(互联网业务), 'trading'(贸易业务), 'service'(服务业务), 'internet_dev'(互联网开发), 'corporate_website'(企业官网-极简风格)
  BUSINESS_TYPE: 'corporate_website', // 默认业务类型，可根据实际业务修改
  
  // 页面显示配置
  PAGE_TITLE: '新疆爱游互娱', // 页面标题/服务名称
  
  // 备案信息
  ICP_NUMBER: '新ICP备2026002725号', // ICP备案号
  ICP_LINK: 'https://beian.miit.gov.cn/', // 工信部备案查询地址
}
